<template>
    <v-row>
        <v-col cols="12" md="5">
            <v-card-subtitle class="title">
                {{ $t('mainStore.personalize.positionSection.title') }} </v-card-subtitle>
            <v-card-text class="grey--text ">
                {{ $t('mainStore.personalize.positionSection.subtitle') }}
            </v-card-text>
        </v-col>
        <v-col cols="12" md="5">
            <div id="app">
                <div class="list pt-3">
                    <!-- <transition-group name="flip-list" tag="div"> -->
                    <!-- :class="{
                    over: item === over.item && item !== dragFrom,
                    [over.dir]:
                      item === over.item && item !== dragFrom,
                  }"  -->
                    <v-card class="py-6 px-6 mb-2" elevation="2" @dragover="(e) => onDragOver(item, i, e)"
                        @dragend="(e) => finishDrag(item, i, e)" @dragstart="(e) => startDrag(item, i, e)"
                        v-for="(item, i) in items" draggable="true" :key="item.id" :disabled="(selectedStore.options.hidePackages && item.id == 'package') || (selectedStore.options.hideAsus && ['formats'].includes(item.id)) ">
                        <div class="d-flex justify-space-between align-center">
                            <div class="d-flex align-center">
                                <div class="mr-2">{{ i + 1 }}.</div>
                                <div>
                                    {{ item.title }}
                                    <div class="mb-n3 text-caption red--text" v-if="(selectedStore.options.hidePackages && item.id == 'package') " v-html="$t('mainStore.personalize.positionSection.packageDisabled')"></div>
                                    <div class="mb-n3 text-caption red--text" v-if="(selectedStore.options.hideAsus && ['formats'].includes(item.id)) "  v-html="$t('mainStore.personalize.positionSection.asuDisabled')"></div>
                                </div>
                                <!-- <v-icon class="ml-2">mdi-pencil-outline</v-icon> -->
                            </div>
                            <div class="d-flex justify-end">
                                <template v-if="(selectedStore.options.hidePackages && item.id == 'package') || (selectedStore.options.hideAsus && ['formats'].includes(item.id)) ">
                                    <v-switch class="mt-n1" hide-details :value="false"></v-switch>
                                </template>
                                <v-switch class="mt-n1" v-else v-model="item.active" hide-details></v-switch>
                            </div>
                        </div>
                    </v-card>
                    <!-- </transition-group> -->
                </div>
            </div>
        </v-col>

    </v-row>
</template>
<script>
import { mapState } from "vuex";

export default {
    name: "PositionsSection",
    data: () => ({
        items: [
            {
                title: "Categories",
                id: 'Categories',
                active: true,
            },
            {
                title: "Paquetes",
                id: 'packages',
                active: true,
            },
            {
                title: "Destacados",
                id: 'Featured',
                active: true,
            },
            {
                title: "Formatos",
                id: 'formats',
                active: true,
            },
            {
                title: "Programas",
                id: 'Programs',
                active: true,
            },

        ],
        over: {},
        startLoc: 0,
        dragging: false,
        dragFrom: {},
    }),

    props: {
        snap: Array,
    },
    mounted() {
        this.items = this.snap
    },

    watch: {
        items: {
            deep: true,
            handler() {
                this.sendSections()
            },
        },
        'selectedStore': {
            deep: true,
            haldler() {
                this.load()
            }
        },
    },
    computed: {
        ...mapState("groupStores", [
            "selectedStore",
        ]),
    },

    methods: {
        sendSections() {
            this.$emit('update-store', this.items)
            console.log('emit', this.items)
        },
        startDrag(item, i, e) {
            this.startLoc = e.clientY;
            this.dragging = true;
            this.dragFrom = item;
        },
        finishDrag(item, pos) {
            this.items.splice(pos, 1);
            this.items.splice(this.over.pos, 0, item);
            this.over = {};
        },
        onDragOver(item, pos, e) {
            const dir = this.startLoc < e.clientY ? "down" : "up";
            setTimeout(() => {
                this.over = { item, pos, dir };
            }, 50);
        },
    }
}
</script>